export enum FeatureToggle {
  connectedStores = 'rt_connected_stores',
  caperTransactions = 'rt_connected_stores_caper_transactions',
}
